// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mergeWithCss } from "@steiner/XDL/Utilities";
import React, { useState } from "react";

interface OwnProps {
    leftTitle?: string;
    rightTitles?: string[];
    extendedStyles?: LinesHeaderStyles;
    isOrderDetailsPage?: boolean;
}

export interface LinesHeaderStyles {
    wrapper?: InjectableCss;
    productInformation?: InjectableCss;
    inventory?: InjectableCss;
    price?: InjectableCss;
    qty?: InjectableCss;
    qtyShipped?: InjectableCss;
    extPrice?: InjectableCss;
    removeLine?: InjectableCss;
}

export const linesHeaderStyles: LinesHeaderStyles = {};

const LinesHeader = ({ leftTitle, rightTitles, extendedStyles, isOrderDetailsPage }: OwnProps) => {
    const [styles] = useState(() => mergeWithCss(linesHeaderStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.wrapper} data-has-qty-shipped={isOrderDetailsPage}>
            <StyledWrapper {...styles.productInformation}>
                <Typography>{translate(leftTitle || "")}</Typography>
            </StyledWrapper>
            {!isOrderDetailsPage && (
                <StyledWrapper {...styles.inventory}>{translate(rightTitles?.[0] || "")}</StyledWrapper>
            )}
            <StyledWrapper {...styles.price} data-has-qty-shipped={isOrderDetailsPage}>{translate(rightTitles?.[1] || "")}</StyledWrapper>
            <StyledWrapper {...styles.qty} data-has-qty-shipped={isOrderDetailsPage}>{translate(rightTitles?.[2] || "")}</StyledWrapper>
            {isOrderDetailsPage && (
                <StyledWrapper {...styles.qtyShipped} data-has-qty-shipped={isOrderDetailsPage}>{translate(rightTitles?.[3] || "")}</StyledWrapper>
            )}
            <StyledWrapper {...styles.extPrice} data-has-qty-shipped={isOrderDetailsPage}>{translate(rightTitles?.[4] || rightTitles?.[3] || "")}</StyledWrapper>
            <StyledWrapper {...styles.removeLine} />
        </StyledWrapper>
    );
};

LinesHeader.defaultProps = {
    leftTitle: translate("Product Information"),
    rightTitles: ["Inventory", "Price", "QTY", "Ext. Price"],
};

export default LinesHeader;
